import api from './api';

export async function getAttendanceDaily(params = {}) {
  const { data } = await api.get('/staff-attendance/daily', { params });
  return data;
}

export async function getAttendanceStaffOptions(params = {}) {
  const { data } = await api.get('/staff-attendance/staff-options', { params });
  return data;
}

export async function getAttendanceMonthly(params = {}) {
  const { data } = await api.get('/staff-attendance/monthly', { params });
  return data;
}

export async function getAttendanceStaffHistory(staffUserId, params = {}) {
  const { data } = await api.get(`/staff-attendance/staff/${staffUserId}`, { params });
  return data;
}

export async function markAttendance(payload) {
  const { data } = await api.post('/staff-attendance/mark', payload);
  return data;
}

export async function markAttendanceAbsent(payload) {
  const { data } = await api.post('/staff-attendance/mark-absent', payload);
  return data;
}

export async function markAttendanceLeave(payload) {
  const { data } = await api.post('/staff-attendance/mark-leave', payload);
  return data;
}

export async function markAttendanceHoliday(payload) {
  const { data } = await api.post('/staff-attendance/mark-holiday', payload);
  return data;
}

export async function checkInAttendance(payload) {
  const { data } = await api.post('/staff-attendance/check-in', payload);
  return data;
}

export async function checkOutAttendance(payload) {
  const { data } = await api.post('/staff-attendance/check-out', payload);
  return data;
}

export async function correctAttendance(payload) {
  const { data } = await api.post('/staff-attendance/correct', payload);
  return data;
}

export async function getTeamMembers(params = {}) {
  const { data } = await api.get('/staff-attendance/team-members', { params });
  return data;
}

export async function createTeamMember(payload) {
  const { data } = await api.post('/staff-attendance/team-members', payload);
  return data;
}

export async function updateTeamMember(teamMemberId, payload) {
  const { data } = await api.put(`/staff-attendance/team-members/${teamMemberId}`, payload);
  return data;
}

export async function regenerateTeamMemberInvite(teamMemberId) {
  const { data } = await api.post(`/staff-attendance/team-members/${teamMemberId}/invite`);
  return data;
}

export async function getTeamToday(params = {}) {
  const { data } = await api.get('/staff-attendance/team-today', { params });
  return data;
}

export async function checkInTeamMember(teamMemberId, payload) {
  const { data } = await api.post(`/staff-attendance/team-members/${teamMemberId}/check-in`, payload);
  return data;
}

export async function checkOutTeamMember(teamMemberId, payload) {
  const { data } = await api.post(`/staff-attendance/team-members/${teamMemberId}/check-out`, payload);
  return data;
}

export async function markTeamAttendance(teamMemberId, payload) {
  const { data } = await api.post(`/staff-attendance/team-members/${teamMemberId}/mark`, payload);
  return data;
}

export async function correctTeamAttendance(attendanceId, payload) {
  const { data } = await api.post(`/staff-attendance/team-attendance/${attendanceId}/correct`, payload);
  return data;
}

export async function getLeaveRequests(params = {}) {
  const { data } = await api.get('/staff-attendance/leave-requests', { params });
  return data;
}

export async function createLeaveRequest(payload) {
  const { data } = await api.post('/staff-attendance/leave-requests', payload);
  return data;
}

export async function decideLeaveRequest(leaveRequestId, payload) {
  const { data } = await api.post(`/staff-attendance/leave-requests/${leaveRequestId}/decision`, payload);
  return data;
}

export async function getPaymentSlips(params = {}) {
  const { data } = await api.get('/staff-attendance/payment-slips', { params });
  return data;
}

export async function upsertPaymentSlip(payload) {
  const { data } = await api.post('/staff-attendance/payment-slips', payload);
  return data;
}

export async function getTeamMonthlySummary(params = {}) {
  const { data } = await api.get('/staff-attendance/team-monthly-summary', { params });
  return data;
}

export async function getAttendanceSettings() {
  const { data } = await api.get('/staff-attendance/settings');
  return data;
}

export async function updateAttendanceSettings(payload) {
  const { data } = await api.put('/staff-attendance/settings', payload);
  return data;
}
